
export const TIME_ENTRY_SCHEDULE_FIELDS = {
start_time: {
    type: "time",
    label: "Start Time",
    placeholder: "Select start time",
    formSpan: 1,
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "timeRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Clock",
    // Internal scheduling granularity — staff only (clients see hours, not raw clock times).
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "work",
  },
end_time: {
    type: "time",
    label: "End Time",
    placeholder: "Select end time",
    formSpan: 1,
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "timeRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Clock",
    // Internal scheduling granularity — staff only (clients see hours, not raw clock times).
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "work",
  }
} as const;
